import React, { useState, useEffect } from 'react';
import { useHistory , useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Routes } from '../../../routes';
import { Timer } from '../../../util/Constant';
import {
  sendVerificationCode,
  setUserSignUp,
  validateVerificationCode,
  setVerificationCodeStatus,
  setValidCode,
} from '../../redux/auth';
import { removeDashInput } from '../../../util/Util';
import { Strings } from '../../shared/constants/Strings';

import { GAProvider } from '../../components/PSAnalytics';
import PSLoginContainer from '../../components/PSLoginContainer';
import PSHeaderLogin from '../../components/PSHeaderLogin';
import PSButton from '../../components/PSButton';
import PSBox from '../../components/PSBox';
import PSLabel from '../../components/PSLabel';
import PSLoginSelectValidation from '../../components/PSLoginSelectValidation';
import PSLogingMessageValidation from '../../components/PSLogingMessageValidation';
import PSTimerValidation from '../../components/PSTimerValidation';
import PSParagraph from '../../components/PSParagraph';
import PSError from '../../components/PSError';
import PSMessageResponse from '../../components/PSMessageResponse';

import './index.scss';

export default function SignUpValidation({ closeModal }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { idValidation } = location.state || {}

  const {
    loading,
    codeSent,
    errorCodeSent,
    signUp: user,
    validCode,
    cognitoCreated,
  } = useSelector((state) => state.auth);
  const [validationType, setValidationType] = useState(user.validationType);
  const [idValid , setIdValid ] = useState('')
  const [sendValidation, setSendValidation] = useState(false);
  const [confirmValidation, setConfirmValidation] = useState(false);
  const [lastPage, setLastPage] = useState(false);
  const [codeValidation, setCodeValidation] = useState(null);
  const [error, setError] = useState(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const [validationCode, setValidationCode] = useState();
  const [exceedAttempts, setExceedAttempts] = useState();
  const [sendCode, setSendCode] = useState(false);
  const [invalidCode, setInvalidCode] = useState(false);
  const ga = React.useContext(GAProvider);

  const onSelectValidation = (value) => {
    setValidationType(value);
    dispatch(setUserSignUp({ validationType: value }));
  };

  const onButtonClick = () => {
    if (confirmValidation) {
      sendCodeValidation();
    } else {
      sendToValidation();
    }
  };

  const sendToValidation = () => {
    if (!validationType) {
      setError('Seleccione una opción');
      return;
    }

    setError(null);

    if (!sendValidation) {
      dispatch(sendVerificationCode( idValid , user ));
    } else if (!confirmValidation) {
      setLastPage(true);
      setConfirmValidation(true);
    }
  };

  const sendCodeValidation = () => {
    if (!removeDashInput(codeValidation)) {
      setError('Ingrese el codigo');
    }
    setError(null);
    dispatch(validateVerificationCode(removeDashInput(codeValidation) , idValid , user));
  };

  const forwardCode = () => {
    setSendCode(true);
    setDisabledButton(false);
    dispatch(setVerificationCodeStatus(false));
    dispatch(sendVerificationCode(idValid , user));
  };

  const getFooterMenssage = () => {
    if (confirmValidation) {
      return '';
    }

    if (sendValidation) {
      return validationType === 'phoneNumber' ? Strings.INFO_PHONE : Strings.INFO_EMAIL;
    }

    return Strings.INFO_PASSWORD;
  };

  const onClose = () => {
    closeModal();
  };

  const isButtonDisabled = () => {
    return disabledButton ||
      validationType === undefined ||
      (lastPage && codeValidation === null) ||
      codeValidation === ''
      ? 'button-disabled'
      : '';
  };

  useEffect(() => {
    if (codeSent) {
      if (sendCode) {
        setSendCode(false);
      }

      setSendValidation(true);

      const typeUser = user.documentType === 'R' ? 'EMPRESA-' : 'PERSONA-';
      const labelGA = `El usuario solicitó el envío de la clave OTP${
        validationType === 'phoneNumber' ? ' por celular' : ' por email'
      }`;

      ga.pageview(window.location.pathname + window.location.search);
      ga.event({
        category: `${typeUser}Enrollment`,
        action: 'click',
        label: labelGA,
        value: 1,
      });
    }
  }, [codeSent]);

  useEffect(() => {
    if (validCode === 'TRIES_EXCEEDED') {
      setExceedAttempts(true);
    }

    if (validCode === 'INVALID_CODE') {
      setInvalidCode(true);
      const documentType = user.documentType.toString();
      const typeUser = documentType === 'R' ? 'EMPRESA-' : 'PERSONA-';

      const labelGA = `El usuario introdujo una clave OTP errónea enviada${
        validationType === 'phoneNumber' ? ' por celular' : ' por email'
      }`;

      ga.pageview(window.location.pathname + window.location.search);
      ga.event({
        category: `${typeUser}Enrollment`,
        action: 'click',
        label: labelGA,
        value: 1,
      });
    }

    if (validCode === 'VALID_CODE') {
      const documentType = user.documentType.toString();
      const typeUser = documentType === 'R' ? 'EMPRESA-' : 'PERSONA-';

      const labelGA = `El usuario validó la clave OTP correctamente enviada${
        validationType === 'phoneNumber' ? ' por celular' : ' por email'
      }`;

      ga.pageview(window.location.pathname + window.location.search);
      ga.event({
        category: `${typeUser}Enrollment`,
        action: 'click',
        label: labelGA,
        value: 1,
      });

      dispatch(setUserSignUp({ code: removeDashInput(codeValidation) }));

      setValidationCode(true);
      setTimeout(() => {
        history.push(Routes.SIGN_UP_CREATE_PASSWORD);
      }, Timer.waitingApi);
    }
  }, [validCode]);
  
  useEffect(() => {
    if (idValidation) {
        setIdValid(idValidation)
    }
  }, [idValidation]);
  
  return (
    <div className="sign-up-validation">
      {!validationCode && !exceedAttempts && !errorCodeSent && (
        <PSLoginContainer className="user-container" onClose={onClose}>
          <PSHeaderLogin
            className="user-header-login"
            title="Solicitud de registro a Net Privada"
            icon="user"
          />

          <div className="user-body-validation">
            {!sendValidation && (
              <PSLoginSelectValidation
                className="user-select-validation"
                onChange={onSelectValidation}
                value={validationType}
              />
            )}

            {sendValidation && !confirmValidation && (
              <PSLogingMessageValidation
                className="user-message-validation"
                type={validationType}
              />
            )}

            {confirmValidation && (
              <PSTimerValidation
                className="user-timer-validation"
                onChange={(e) => {
                  setInvalidCode(false);
                  setCodeValidation(e.target.value);
                  dispatch(setValidCode(null));
                }}
                value={codeValidation}
                setDisabledProp={(value) => setDisabledButton(value)}
                refresh={sendCode}
                error={confirmValidation && invalidCode}
              />
            )}

            {error && <PSError>{error}</PSError>}
            {confirmValidation && invalidCode && (
              <PSError>
                *El código de verificación que ingresaste no es correcto vuelve a solicitar el envío
              </PSError>
            )}
          </div>
          <PSBox className="container-footer-buttons">
            <PSButton
              onClick={onButtonClick}
              disabled={
                confirmValidation ? codeValidation == null || codeValidation === '' : disabledButton
              }
              className={isButtonDisabled()}
              loading={!sendCode && loading}
            >
              Aceptar
            </PSButton>
          </PSBox>
          {confirmValidation && (
            <PSBox className="container-footer-buttons">
              <PSLabel>¿No recibiste el código de verificación?</PSLabel>
              <PSButton
                onClick={forwardCode}
                loading={sendCode && loading}
                className="btn-secondary"
              >
                Reenviar
              </PSButton>
            </PSBox>
          )}
          <PSBox className="user-footer-message">
            <PSParagraph>{getFooterMenssage()}</PSParagraph>
          </PSBox>
        </PSLoginContainer>
      )}

      {validationCode && <PSMessageResponse title="Validación exitosa" icon="successFace" />}

      {exceedAttempts && (
        <PSMessageResponse
          onClose={onClose}
          title={Strings.PASSWORD_EXCEEDED_TRY_TITlE}
          icon="failed"
        >
          {Strings.PASSWORD_EXCEEDED_TRY}
        </PSMessageResponse>
      )}
      
       {errorCodeSent && (
        <PSMessageResponse onClose={onClose} title={Strings.SEND_EXCEEDED_TRY_TITLE} icon="failed">
          {Strings.SEND_EXCEEDED_TRY}
        </PSMessageResponse>
      )}
    </div>
  );
}
